import React from "react";
import theme from "../theme/theme1";


const LibrariesSection = () => {
  return (
    <section
      className="py-12 px-4 sm:px-6 lg:px-8"
      style={{ backgroundColor: "#13294b" }}
    >
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start relative">
        {/* Left Card Section */}
        <div
          className="p-8 shadow-lg lg:w-7/12 relative z-0"
          style={{
            backgroundColor: theme.librariesSection.cardBackground,
            fontFamily: theme.librariesSection.fontFamily,
          }}
        >
          <h2
            className="text-4xl font-bold mb-6"
            style={{ color: theme.librariesSection.headingTextColor }}
          >
            Libraries
          </h2>

          <div className="mb-8">
            <h3
              className="text-xl font-semibold"
              style={{ color: theme.librariesSection.subHeadingTextColor }}
            >
              Velammal Bodhi Libraries
            </h3>
            <p className="mt-2" style={{ color: theme.librariesSection.textColor }}>
              Velammal is home to more than 20 individual libraries, each with a
              world-class collection of books, journals, films, maps, and
              databases.
            </p>
            <button
              type="button"
              className="font-semibold mt-4 inline-block transition-colors duration-300"
              style={{ color: theme.librariesSection.linkTextColor }}
              onMouseEnter={(e) => {
                e.target.style.color = theme.librariesSection.linkHoverTextColor;
              }}
              onMouseLeave={(e) => {
                e.target.style.color = theme.librariesSection.linkTextColor;
              }}
            >
              Velammal Bodhi Libraries &gt;
            </button>
          </div>

          <div>
            <h3
              className="text-xl font-semibold"
              style={{ color: theme.librariesSection.subHeadingTextColor }}
            >
              Online Catalog
            </h3>
            <p className="mt-2" style={{ color: theme.librariesSection.textColor }}>
              SearchWorks is Velammal Bodhi Libraries’ official online search tool
              providing metadata about the 8 million+ resources in our physical and
              online collections.
            </p>
            <button
              type="button"
              className="font-semibold mt-4 inline-block transition-colors duration-300"
              style={{ color: theme.librariesSection.linkTextColor }}
              onMouseEnter={(e) => {
                e.target.style.color = theme.librariesSection.linkHoverTextColor;
              }}
              onMouseLeave={(e) => {
                e.target.style.color = theme.librariesSection.linkTextColor;
              }}
            >
              SearchWorks &gt;
            </button>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="lg:absolute lg:right-0 lg:top-8 mt-8 lg:mt-0 lg:w-5/12 transform lg:-translate-x-10 lg:translate-y-8 flex justify-center z-10">
          <img
            src="https://www.stanford.edu/wp-content/uploads/2022/08/20220414_Libraries_N6A7046-2048x1366.jpg"
            alt="Library"
            className="shadow-lg max-w-full"
            style={{ boxShadow: theme.librariesSection.imageShadow }}
          />
        </div>
      </div>
    </section>
  );
};

export default LibrariesSection;
